import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

const SectionWrapper = styled.section`
  padding: 100px 0 0px;
  @media only screen and (max-width: 990px) {
    padding: 80px 0 0px;
  }
  @media only screen and (max-width: 480px) {
    padding: 50px 0 0px;
  }
`

export const Section = styled.div`
  display: flex;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
  p {
    font-weight: 300;
    font-size: 20px;
    line-height: 30px;
    @media only screen and (max-width: 990px) {
      font-size: 18px;
    }

    @media only screen and (max-width: 480px) {
      font-size: 16px;
      line-height: 28px;
    }
  }
`

export const ColumnA = styled.figure`
  width: 35%;
  margin: 0 10% 0 0;
  .first-part {
    margin-bottom: 0px;

    @media only screen and (max-width: 990px) {
      font-size: 40px;
    }
    @media screen and (max-width: 480px) {
      font-size: 36px;
      line-height: 40px;
      margin-bottom: 16px;
    }
  }
  .colored-part {
    color: ${themeGet("colors.mainBlue")};
    @media only screen and (max-width: 990px) {
      font-size: 40px;
    }
    @media screen and (max-width: 480px) {
      font-size: 36px;
      line-height: 40px;
    }
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin: 0 0 0 0;
  }
`
export const ColumnB = styled.div`
  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p:first-child {
      margin: 0 0 15px 0;
    }
    p:last-child {
      margin: 0 0 0 0;
    }
  }

  width: 55%;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`

export default SectionWrapper
